import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-384cf3ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Strojní vybavení")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Pronájem strojů")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Historie staveb")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Kontakty")




export default /*#__PURE__*/_defineComponent({
  props: {
    mobile: { type: Boolean },
    mobileMenuOpened: { type: Boolean }
  },
  emits: ['routerClick'],
  setup(__props: any, { emit }) {

const props = __props as {
  mobile: boolean,
  mobileMenuOpened: boolean
}





function handleClick(){
  if(props.mobile){
    emit('routerClick')
  }
}



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, {
      to: "/strojni-vybaveni",
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/pronajem-stroju",
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/historie-staveb",
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/kontakty",
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ], 512)), [
    [_vShow, props.mobileMenuOpened || !props.mobile]
  ])
}
}

})